class SeoText {
  constructor(root) {
    this.root = root;
    this.content = root.querySelector('[data-seo-text-content]');
    this.toggle = root.querySelector('[data-seo-text-toggle]');
    this.label = root.querySelector('[data-seo-text-label]');
    this.labelMore = root.dataset.labelMore;
    this.labelLess = root.dataset.labelLess;
    this.minExtra = 48; // px extra minimi per giustificare il bottone
    this.lastWidth = 0;

    this.toggle.addEventListener('click', () => this.setExpanded(!this.expanded));

    // Reagisce solo ai cambi di larghezza (evita loop con le transizioni di altezza)
    this.ro = new ResizeObserver(([entry]) => {
      const w = Math.round(entry.contentRect.width);
      if (w !== this.lastWidth) {
        this.lastWidth = w;
        this.evaluate();
      }
    });
    this.ro.observe(this.root);

    // Ri-misura dopo il caricamento di font/immagini
    if (document.fonts?.ready) document.fonts.ready.then(() => this.evaluate());
    window.addEventListener('load', () => this.evaluate());
  }

  get expanded() {
    return this.root.classList.contains('is-expanded');
  }

  evaluate() {
    const wasExpanded = this.expanded;

    // Misura con stato collassato
    this.root.classList.remove('is-expanded');
    this.root.classList.add('is-collapsible');

    const full = this.content.scrollHeight;
    const collapsed = this.content.clientHeight;
    const needsToggle = full - collapsed > this.minExtra;

    if (!needsToggle) {
      this.root.classList.remove('is-collapsible', 'is-expanded');
      this.toggle.hidden = true;
      return;
    }

    this.root.style.setProperty('--seo-full-height', `${full}px`);
    this.toggle.hidden = false;
    this.setExpanded(wasExpanded, { scroll: false });
  }

  setExpanded(state, { scroll = true } = {}) {
    this.root.classList.toggle('is-expanded', state);
    this.toggle.setAttribute('aria-expanded', String(state));
    this.label.textContent = state ? this.labelLess : this.labelMore;

    // Quando richiudi, riporta in vista l'inizio del blocco se è fuori schermo
    if (!state && scroll) {
      const top = this.root.getBoundingClientRect().top;
      if (top < 0) this.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}

const initSeoText = (scope = document) =>
  scope.querySelectorAll('[data-seo-text]').forEach((el) => {
    if (!el._seoText) el._seoText = new SeoText(el);
  });

initSeoText();

// Theme editor di Shopify
document.addEventListener('shopify:section:load', (e) => initSeoText(e.target));